import { styled } from '@mui/material';

export const CoverageButtonStyled = styled('button')({
  width: '100%',
  backgroundColor: 'white',
  borderRadius: '4px',
  padding: '16px 24px',
  marginBottom: '8px',
  border: '1px solid #e0e0e0',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  textAlign: 'start',
  '@media (max-width: 743px)': {
    padding: '16px 8px 16px 24px',
  },
});

export const ElectionWrapperStyled = styled('div')({
  width: '100%',
});

export const PlanInfoContainerStyled = styled('div')({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  '@media (min-width: 744px)': {
    marginBottom: '12px',
  },
  h3: {
    fontSize: '16px',
    fontWeight: '600',
    lineHeight: '24px',
  },
});

export const CarrierNameStyled = styled('p')({
  fontSize: '16px',
});

export const ElectionTitleWrapperStyled = styled('div')({
  maxWidth: '304px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  textWrap: 'wrap',
});

export const PremiumWrapperStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  '@media (max-width: 743px)': {
    p: {
      whiteSpace: 'nowrap',
    },
  },
});

export const PremiumPerPayTextStyled = styled('p')({
  fontSize: '12px',
});

export const DeclineIconSyled = styled('div')({
  width: '24px',
  height: '24px',
});